module.exports = __webpack_public_path__ + "img/posterUrl.bf789b82.png";